/* tslint:disable */

declare var Object: any;
export interface ReleaseNotesInterface {
  "id"?: number;
  "UserId"?: number;
  "Version"?: string;
  "types"?: string;
  "description"?: string;
  "Orders"?: string;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class ReleaseNotes implements ReleaseNotesInterface {
  "id": number;
  "UserId": number;
  "Version": string;
  "types": string;
  "description": string;
  "Orders": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ReleaseNotesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ReleaseNotes`.
   */
  public static getModelName() {
    return "ReleaseNotes";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ReleaseNotes for dynamic purposes.
  **/
  public static factory(data: ReleaseNotesInterface): ReleaseNotes{
    return new ReleaseNotes(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ReleaseNotes',
      plural: 'ReleaseNotes',
      path: 'ReleaseNotes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "UserId": {
          name: 'UserId',
          type: 'number'
        },
        "Version": {
          name: 'Version',
          type: 'string'
        },
        "types": {
          name: 'types',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "Orders": {
          name: 'Orders',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
